<template>
  <div id="app">
    <router-view/>
    <div class="bottom">
      <a   target="view_window" href="https://a.app.qq.com/o/simple.jsp?pkgname=com.psyone.brainmusic" >
      <div class="bottom-img">
        <img  class='bottom-hehe' src="./assets/a.png"/>
      </div>
      </a>
      <a   target="view_window" href="https://a.app.qq.com/o/simple.jsp?pkgname=com.psyone.brainmusic" >
      <p class="bottom-center">下载小睡眠App，聆听晚安电台</p>
      </a>
      <a class="dl"  target="view_window" href="https://a.app.qq.com/o/simple.jsp?pkgname=com.psyone.brainmusic" >
        <p class="bottom-dl">下&nbsp;&nbsp;载</p>
      </a>
    </div>
    <transition name="fade">
      <div class="warn-open-outer" v-if="show">
        <div class="warn">
          <p class="title">试听结束</p>
          <!-- <p class="center">你的试听已结束，赶紧前往小睡眠App体验更多音频吧 (～￣▽￣)～</p> -->
          <p @click="aa" class="warn-open">确定</p>
          <img @click="hehe" class="close" src="./assets/btn_close@3x.png"/>
        </div>
      </div>

    </transition>
    <transition name="fade">
      <div class="outer-tips" v-if="tips_toggle" @click="tips_toggle = false">
        <img src="./assets/jt.png" class="outer-tips-png"/>
        <div  class="tips">点击右上角用<span style="color: #FFCA72">「浏览器」</span>打开</div>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="tips_toggle2" class="tips">已经没有啦~</div>
    </transition>
  </div>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      tips_toggle: false,
      tips_toggle2: false
    }
  },
  methods: {
    hehe () {
      this.show = !this.show
      document.querySelector('#myaudio').currentTime = 0
      if (this.$children[0].$children[0].toggle == false) {
        // this.$children.getDataFromApi(12345, 2)
         document.querySelector('#myaudio').play()
      }
    },
    appOpenSet () {
      const that = this
      var  createIframe=(function(){
        var iframe;
        return function(){
          if(iframe){
            return iframe;
          }else{
            iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
            return iframe;
          }
        }
      })()

      var baseScheme = "cosleep://"
      var createScheme=function(options){
        var urlScheme=baseScheme;
        for(var item in options){
          urlScheme=urlScheme+item + '=' + encodeURIComponent(options[item]) + "&";
        }
        urlScheme = urlScheme.substring(0, urlScheme.length - 1);
        return encodeURIComponent(urlScheme);
      }

      var openApp=function(){

        console.log( 'cosleep://deeplink?code=10012&broadcast_id=' + that.$children[0].now_id )
        var localUrl=createScheme();
        var openIframe=createIframe();
        if(/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)){
          //判断是否是ios,具体的判断函数自行百度
          //alert("cosleep://deeplink?code=10010&music_detail_code="+that.code)



            window.location.href = "https://www.psy-1.com/app/redirect?code=10012&broadcast_id=" + that.$children[0].now_id // &music_detail_code="+that.code // +"&"+ encodeURI( that.musicDetail() )
          that.toDownLoad()


          var loadDateTime = Date.now();
          setTimeout(function () {
            var timeOutDateTime = Date.now();
            if (timeOutDateTime - loadDateTime < 1000) {
              // window.location.href = "cosleep://deeplink?code=10010&music_detail_code="+that.code
              // window.location.href = 'cosleep://deeplink?code=10010&music_detail_code=kZkCCukLd3CHWMWZ'
              // console.log(decodeURI("cosleep://deeplink?code=10010&music_detail_code="+that.code +"&"+ encodeURI( that.musicDetail() )))

                window.location.href = "cosleep://deeplink?code=10012&broadcast_id=" + that.$children[0].now_id // &music_detail_code="+that.code // +"&"+ encodeURI( that.musicDetail() )
              that.toDownLoad()



            }
          }, 25);
        }else if(!/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)){
          //判断是否是android，具体的判断函数自行百度
          if (false) {
            //chrome浏览器用iframe打不开得直接去打开，算一个坑
            window.location.href = localUrl;
          } else {
            //抛出你的scheme
            openIframe.src = localUrl;
          }
          setTimeout(function () {
            //alert("cosleep://deeplink?code=10010&music_detail_code="+this.code)


              window.location.href = "cosleep://deeplink?code=10012&broadcast_id=" + that.$children[0].now_id // "// &music_detail_code="+that.code // +"&"+ encodeURI( that.musicDetail() )
            that.toDownLoad()



            //window.location.href = 'cosleep://deeplink?code=10010&music_detail_code=kZkCCukLd3CHWMWZ'
          }, 500);
        }else{
          //主要是给winphone的用户准备的,实际都没测过，现在winphone不好找啊
          openIframe.src = localUrl;
          setTimeout(function () {
            window.location.href = "https://www.heartide.com/download/smallsleep";
          }, 500);
        }
      }
      openApp()
    },
    aa () {
      if(!this.$store.getters.isWeiXin){
        this.appOpenSet()
      } else {
        this.hehe()
        // this.tips_toggle = true
        // setTimeout(()=>{
        //   this.tips_toggle = false
        // },5000)
      }
    },
    aa2 () {
      this.tips_toggle2 = true
      setTimeout(()=>{
        this.tips_toggle2 = false
      },1000)
    },
    toDownLoad(){
      setTimeout(function () {
        window.location.href = "https://www.heartide.com/download/smallsleep";
      }, 3000);
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: px2html(10px);
}

.outer-tips {
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 999999;
  background-color: rgba(0,0,0,0.5);
  font-family:NotoSansCJKsc-Bold;
  font-size:px2html(18px);
  font-weight:bold;
  .outer-tips-png {
    position: absolute;
    top:px2html(10px);
    right:px2html(22px);
    width: px2html(62px);
    height: px2html(47px);
  }
}

.tips{
  position:fixed;
  top: px2html(60px);
  right:px2html(10px);
  color:#fff;
  padding:px2html(8px);
  border-radius:px2html(10px);
  padding-left:px2html(15px);
  padding-right:px2html(15px);
  z-index:99999;
  //width:px2html(375px);
}

.warn-open-outer{
  width:100%;
  height:100%;
  position:absolute;
  left:0px;
  top:0px;
  z-index:9999;
  background-color: rgba(0,0,0,0.3);
  .warn{
    position:fixed;
    background-color: #fff;
    border-radius: px2html(12px);
    right:50%;
    top:50%;
    width:px2html(290px);
    height:px2html(185px);
    z-index:99;
    transform: translateX(50%) translateY(-50%);
    // color:#fff;
    font-size:px2html(12px);
    display:flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
    .title{
      font-size:px2html(18px);
    }
    .center{
      // font-weight: 100;
      width:px2html(185px);
       color: #A3A3A3;
      text-align: left;
      font-size:px2html(12px);
    }

    .warn-open{
      padding: px2html(19px);
      font-size:px2html(12px);
      color:#fff;
      padding-top:px2html(7px);
      padding-bottom:px2html(7px);
      border-radius: px2html(30px);
      border:px2html(1px) #3FA8F4 solid;
      background-color: #3FA8F4;
    }

    .close{
      position:absolute;
      right:px2html(10px);
      top:px2html(10px);
      width:px2html(20px);
      height:px2html(20px);
      filter: brightness(0%);
      // filter: blur;
    }

  }
}

.bottom{
  height:px2html(40px);
  //overflow:hidden;
  background:#312736;
  width:px2html(375px);
  position:fixed;
  bottom:0%;
  left:0px;

  font-size:px2html(15px);
  color:#fff;
  .bottom-img{
    width:px2html(60px);
    position:relative;
    position:absolute;
    height:px2html(61px);
    left:px2html(-3px);
    top:px2html(-16px);
    .bottom-hehe{
      position:absolute;
      height:px2html(60px);
      width: px2html(60px);
      left:px2html(9px);
      top:px2html(-6px);
      z-index:999;
    }
  }

  .bottom-center{
    position:absolute;
    right:52%;
    top:50%;
    width:100%;
    transform: translateX(50%) translateY(-50%);
    color: #837D86;
    font-family: PingFangSC;
  }
  .bottom-dl{
    position:absolute;
    right:px2html(40px);
    top:50%;
    background-color: #5A525E;
    padding:px2html(10px);
    color: #fff;
    padding-top:px2html(1px);
    padding-bottom:px2html(1px);
    border-radius:px2html(18px);
    transform: translateX(50%) translateY(-50%);
  }
}
</style>
